// AddComment.jsx (FULL) — UI modern + loading + counter + Enter to send (Ctrl+Enter) + mesaje frumoase
import React, { useMemo, useState } from "react";
import "../../styles/produs/AddComments.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperPlane, faSpinner, faLock } from "@fortawesome/free-solid-svg-icons";
import api from "../../api/http";

const MAX_LEN = 600;

const AddComment = ({ productId, onSuccess }) => {
  const [comment, setComment] = useState("");
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const isLoggedIn = Boolean(sessionStorage.getItem("access"));

  const remaining = useMemo(() => MAX_LEN - comment.length, [comment.length]);

  const parseError = (err) => {
    const data = err?.response?.data;
    if (!data) return "Eroare la adăugarea comentariului.";
    if (typeof data === "string") return data;
    if (typeof data.detail === "string") return data.detail;
    if (typeof data === "object") {
      return Object.entries(data)
        .map(([k, v]) => `${k}: ${Array.isArray(v) ? v.join(", ") : String(v)}`)
        .join("\n");
    }
    return "Eroare la adăugarea comentariului.";
  };

  const handleSubmit = async () => {
    setError("");
    setSuccessMessage("");

    if (!isLoggedIn) {
      setError("Trebuie să vă autentificați pentru a adăuga un comentariu.");
      return;
    }
    if (!productId) return;

    const text = comment.trim();
    if (!text) {
      setError("Scrie un comentariu înainte să trimiți.");
      return;
    }

    if (text.length > MAX_LEN) {
      setError(`Comentariul este prea lung. Max ${MAX_LEN} caractere.`);
      return;
    }

    try {
      setLoading(true);

      const res = await api.post("/produs/comments", {
        comment: text,
        produs: productId,
      });

      if (res.status === 200 || res.status === 201) {
        setComment("");
        setSuccessMessage("Comentariu adăugat cu succes.");
        if (typeof onSuccess === "function") onSuccess();
        setTimeout(() => setSuccessMessage(""), 2500);
      }
    } catch (err) {
      if (err?.response?.status === 401) {
        setError("Sesiunea a expirat. Te rog loghează-te din nou.");
        return;
      }
      setError(parseError(err));
    } finally {
      setLoading(false);
    }
  };

  const onKeyDown = (e) => {
    // Ctrl+Enter trimite
    if (e.key === "Enter" && (e.ctrlKey || e.metaKey)) {
      e.preventDefault();
      if (!loading) handleSubmit();
    }
  };

  return (
    <div className="srAddComment">
      <div className="srAddComment_head">
        <div className="srAddComment_title">Adaugă comentariu</div>

      </div>

      <div className={`srAddComment_box ${!isLoggedIn ? "is-locked" : ""}`}>
        <textarea
          className="srAddComment_textarea"
          rows={4}
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          onKeyDown={onKeyDown}
          placeholder={
            isLoggedIn
              ? "Scrie un comentariu… (Ctrl+Enter pentru trimitere)"
              : "Loghează-te ca să scrii un comentariu"
          }
          disabled={!isLoggedIn || loading}
        />

        {!isLoggedIn && (
          <div className="srAddComment_lock">
            <FontAwesomeIcon icon={faLock} />
            <span>Autentificare necesară</span>
          </div>
        )}
      </div>

      <div className="srAddComment_actions">
        <button
          type="button"
          className="srAddComment_btn"
          onClick={handleSubmit}
          disabled={!isLoggedIn || loading || !comment.trim()}
        >
          {loading ? (
            <>
              <FontAwesomeIcon icon={faSpinner} className="srAddComment_spin" />
              <span>Se trimite…</span>
            </>
          ) : (
            <>
              <FontAwesomeIcon icon={faPaperPlane} />
              <span>Trimite</span>
            </>
          )}
        </button>
      </div>

      {error && <div className="srAddComment_error">{error}</div>}
      {successMessage && <div className="srAddComment_success">{successMessage}</div>}
    </div>
  );
};

export default AddComment;